import { Box, Typography } from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

export default function StoreEmptyState() {
  return (
    <Box
      sx={{
        py: { xs: 6.5, md: 8 },
        px: 2,
        borderRadius: "24px",
        bgcolor: "#ffffff",
        border: "1px solid rgba(0,0,0,0.08)",
        textAlign: "center",
        boxShadow: "0 10px 28px rgba(0,0,0,0.04)",
      }}
    >
      <Inventory2OutlinedIcon
        sx={{
          fontSize: 54,
          color: "#111111",
          mb: 1.1,
        }}
      />

      <Typography
        sx={{
          fontSize: { xs: 22, md: 25 },
          fontWeight: 800,
          color: "#111111",
          mb: 0.7,
        }}
      >
        No encontramos productos
      </Typography>

      <Typography
        sx={{
          fontSize: 14.2,
          fontWeight: 500,
          color: "#666666",
          maxWidth: 500,
          mx: "auto",
        }}
      >
        Prueba cambiando los filtros o la búsqueda para ver más resultados.
      </Typography>
    </Box>
  );
}